export const SESSION_STEP_KEYS_BY_JOURNEY = {
  TRAVEL: {
    PERSONAL_DETAILS: "step_1_pre_request",
    PRE_QUOTE_DETAILS: "step_2_pre_request",
  },
  MOTOR: {
    PERSONAL_DETAILS: "step_1_pre_request",
    PRE_QUOTE_DETAILS: "step_2_pre_request",
    DRIVER_DETAILS: "step_3_pre_request",
  },
  HEALTH: {
    PERSONAL_DETAILS: "step_1_pre_request",
    HEALTH_DETAILS: "step_2_pre_request",
    HEALTH_HABITS: "step_3_pre_request",
    QUICK_QUESTIONS: "step_4_pre_request",
  },
  POST_QUOTE: {
    SELECTED_QUOTE: "selected_quote",
    DOCUMENT_UPLOAD: "step_5_post_request",
    ADDITIONAL_INFO: "step_6_post_request",
    PAYMENT: "step_7_post_request",
  },
} as const;

// Backward compatibility for existing flows. Prefer SESSION_STEP_KEYS_BY_JOURNEY for new code.
export const SESSION_STEP_KEYS = {
  PERSONAL_DETAILS: SESSION_STEP_KEYS_BY_JOURNEY.TRAVEL.PERSONAL_DETAILS,
  PRE_QUOTE_DETAILS: SESSION_STEP_KEYS_BY_JOURNEY.TRAVEL.PRE_QUOTE_DETAILS,
  DRIVER_DETAILS: SESSION_STEP_KEYS_BY_JOURNEY.MOTOR.DRIVER_DETAILS,
  SELECTED_QUOTE: SESSION_STEP_KEYS_BY_JOURNEY.POST_QUOTE.SELECTED_QUOTE,
  DOCUMENT_UPLOAD: SESSION_STEP_KEYS_BY_JOURNEY.POST_QUOTE.DOCUMENT_UPLOAD,
  ADDITIONAL_INFO: SESSION_STEP_KEYS_BY_JOURNEY.POST_QUOTE.ADDITIONAL_INFO,
  PAYMENT: SESSION_STEP_KEYS_BY_JOURNEY.POST_QUOTE.PAYMENT,
} as const;
